import React, { useState, useEffect, useCallback } from 'react';
import { Button, Drawer, Input, Space, Image, Card, Col, Row, Checkbox,message,Spin,Radio,Modal,Table,Avatar} from 'antd';
import { SortableContainer, SortableElement } from 'react-sortable-hoc';
import {arrayMoveMutable,arrayMoveImmutable} from 'array-move';
import config from '../../config'
import { CloseSquareFilled } from '@ant-design/icons';
import {getYunYingOssSecret} from "../../components/Uploader/oss";
import Api from "../../api";
import axios from 'axios';

export default function () {
    const [open, setOpen] = useState(false);
    const [list, setList] = useState([])
    // const [listTotal, setListTotal] = useState([])
    const [filterlist, setFilterlist] = useState([])
    const [selectList, setSelectList] = useState([])
    const [editSource, setEditSource] = useState(false)
    const [isSort,setSort]= useState({
        proposedList:false,
        definiteList:false
    })
    const [loading,setLoading] = useState(false);
    const [stage,setStage] = useState(9)
    const [jsonData,setJsonData] = useState({
        proposedList:[],
        definiteList:[]
    })
    const [selectType, setSelectType] = useState(1)
    const [searchValue, setSearchValue] = useState([])
    const showDrawer = (list, type) => {
        setOpen(true);
        let sList = [];
        for(let i = 0;i<list.length;i++){
            sList.push(list[i].id)
        }
        setSelectList(sList)
        setSelectType(type)
    };

    const doSearch = useCallback((e) => {
        const filterlist = list.filter(item => item.title.indexOf(e.target.value) != -1);
        if(e.target.value){
            setFilterlist(filterlist)
        }else{
            setFilterlist(list)
        }
        setSearchValue(e.target.value)
    })

    const columns1 = [
        {
          title: '学校名称',
          dataIndex: 'name',
          render: (_, record) =>{
           return  <div><Avatar src={<img src={record.picUrl} alt="avatar" />}></Avatar> {record.title}</div>  
          }
        },
        {
          title: '生源表地址',
          render: (_, record,index) =>{
            return  <Input defaultValue={record.sourceUrl} onBlur={(e)=>sourceEdit(e.target.value,"proposedList",index)}></Input>  
           }
        }
      ];
    const columns2 = [
        {
          title: '学校名称',
          dataIndex: 'name',
          render: (_, record) =>{
           return  <div><Avatar src={<img src={record.picUrl} alt="avatar" />}></Avatar> {record.title}</div>  
          }
        },
        {
          title: '生源表',
          render: (_, record,index) =>{
            return  <Input defaultValue={record.sourceUrl} onBlur={(e)=>sourceEdit(e.target.value,"definiteList",index)}></Input>  
           }
        }
      ];

      const sourceEdit = useCallback((value,type,index)=>{

        let arr = JSON.parse(JSON.stringify(jsonData));

        arr[type][index].sourceUrl=value;

        setJsonData(arr)
      })

    useEffect(() => {
        Api.getPictureLibList()
            .then(resp => {
                console.log(resp)
                let arr = []
                for(let i = 0;i<resp.list.length;i++){
                    arr.push({
                        id:resp.list[i].id,
                        picUrl:resp.list[i].picUrl,
                        title:resp.list[i].title,
                        sourceUrl:""
                    })
                }
                setList(arr || [])
                setFilterlist(arr || [])
                // setListTotal(arr || [])
        })
            
        getJsonData(); 
    }, [])

    const getJsonData = useCallback(()=>{
        axios.get(config.OSS+"/yunying/"+stage+"/"+config.JsonName+".json?t="+new Date().getTime()).then(res=>{
            setJsonData(res.data)
            
        }).catch(_=>{
            // message.error("未查询到数据")
            setJsonData({
                proposedList:[],
                definiteList:[]
            })
        })
    })

    useEffect(()=>{
        getJsonData();
    },[stage])

    const onCheckboxChange = useCallback((checkedValues) => {
        setSelectList(checkedValues)
    });

    const selectFn = useCallback(() => {
        let arr = [];
        for(let i = 0;i<selectList.length;i++){
            // 因为图库数据不含生源表地址，先选择从JSON文件里拿数据，JSON文件找不到此数据再从图库拿数据
            const item = jsonData[selectType].filter(item => item.id==selectList[i])[0]; 
            const item2 = list.filter(item => item.id==selectList[i])[0];
            arr.push(item||item2)
        }

        setJsonData({...jsonData,[selectType]:arr})
        setSelectList([]);
        setOpen(false)
    })

    const selectAll = useCallback(() => {
        if(filterlist.length>selectList.length){
            let arr = [];
            for(let i = 0;i<filterlist.length;i++){
                arr.push(filterlist[i].id)
            }
            setSelectList(arr);
        }else{
            setSelectList([]);
        }
    })

    const removeItem = useCallback((id,type) => {
        let arr = jsonData[type];
        let newArr = arr.filter((item)=>{
            return item.id != id;
        });
        setJsonData({...jsonData,[type]:newArr})
    })


    const SortableItem = SortableElement(({ item,type}) =>  
            <div style={{position:'relative',textAlign:'center',height:130,width:120,display:'inline-block',verticalAlign:'top',boxSizing:'border-box',cursor:'pointer',border:'1px solid #f2f2f2',padding:10,margin:5,background:'#fff'}}>
                {
                    isSort[type]?
                    <CloseSquareFilled className="closeSortableItem" onClick={()=>removeItem(item.id,type)} style={{position:'absolute',right:0,top:0,fontSize:20}} />:''
                }
                <Image
                    placeholder={true}
                    preview={false}
                    width={70}
                    height={70}
                    src={item.picUrl}
                    alt={item.title}
                />
                <div style={{marginTop:10,fontSize:12}}>
                    {item.title.split("-")[0]}
                    <br />
                    {item.title.split("-")[1]}
                </div>
            </div>
        );

    const SortableList = SortableContainer(({ list,type}) => {
        return (
            <div style={{height:800,overflow:'scroll'}}>
                {list.map((item, index) => (
                    <SortableItem type={type} key={`item-${item.id}`} index={index} item={item} />
                ))}
            </div>
        );
    });

    const onSortEnd = useCallback(({ oldIndex, newIndex },list) => {
        setJsonData({...jsonData,[list]:arrayMoveImmutable(jsonData[list], oldIndex, newIndex)})
    });

    const submitInfo = useCallback(()=>{
        setLoading(true)
        const jsonStrings = JSON.stringify(jsonData);
        // 创建Blob对象
        const blob = new Blob([jsonStrings],{type:'application/json'});
        //转成文件
        const file = new File([blob],config.JsonName+'.json',{type:'application/json'});

        getYunYingOssSecret({ dir:stage}).then(res => {
            let data = res.info
            const formData = new FormData();
            const key = `${data.dir}/${config.JsonName}.json`;
            formData.append('key',key)
            formData.append('policy', data.policy)
            formData.append('OSSAccessKeyId', data.accessid)
            formData.append('success_action_status', 200)
            formData.append('signature', data.signature)
            formData.append('file', file);
            message.loading('正在提交',30)
            return new Promise(function (resolve, reject) {
                return axios.post(data.host, formData)
                    .then(_ => {
                        console.log(data.host+'/'+key)
                        setTimeout(_=>{
                            message.success("提交成功")
                            setLoading(false)
                        },5000)
                    }).catch((error) => {
                        reject(error);
                    });
            });
        })
    })

    return (
        <Spin spinning={loading}>
        <div className="white-bg pdh16 pdv32 mgv12">
            <div style={{marginBottom:30}}>
             {/* 当前届数：<InputNumber style={{position:"relative",top:-5}} min={1} max={99} value={stage} onChange={(e)=>{console.log(e);setStage(e)}} /> <Button onClick={getJsonData} type="primary">查询</Button> */}
             当前届数： <Radio.Group value={stage} onChange={(e)=>{setStage(e.target.value)}} style={{ marginBottom: 16 }}>
                        <Radio.Button value={6}>第六届</Radio.Button>
                        <Radio.Button value={7}>第七届</Radio.Button> 
                        <Radio.Button value={8}>第八届</Radio.Button> 
                        <Radio.Button value={9}>第九届</Radio.Button> 
                        <Radio.Button value={10}>第十届</Radio.Button> 
                    </Radio.Group>
            <Button style={{float:'right'}} type='primary' loading={loading} disabled={loading} onClick={submitInfo}>提交信息</Button>
            </div>
            <Row gutter={[16, 8]} wrap>
                <Col xl={12} lg={24} md={24} sm={24} xs={24}>
                    <Card
                        title="拟邀名单"
                        extra={<><Button type='link' onClick={() =>{setSort({...isSort,proposedList:!isSort.proposedList})} }>{isSort.proposedList?'取消删除':'删除'}</Button><Button type='link' onClick={() => showDrawer(jsonData.proposedList, 'proposedList')}>添加</Button></>}
                    >
                        <SortableList  axis="xy" useDragHandle={isSort.proposedList} type="proposedList" list={jsonData.proposedList} onSortEnd={(e)=>onSortEnd(e,'proposedList')} />
                    </Card>
                </Col>
                <Col xl={12} lg={24} md={24} sm={24} xs={24}>
                    <Card
                        title="确定参与名单"
                        extra={<><Button type='link' onClick={() =>{setSort({...isSort,definiteList:!isSort.definiteList})} }>{isSort.definiteList?'取消删除':'删除'}</Button><Button type='link'onClick={() => showDrawer(jsonData.definiteList, 'definiteList')}>添加</Button></>}
                    >
                        <SortableList axis="xy"  useDragHandle={isSort.definiteList} type="definiteList" list={jsonData.definiteList} onSortEnd={(e)=>onSortEnd(e,'definiteList')} />
                    </Card>
                </Col>
            </Row>
            <Row>
                <Button type='primary' style={{marginTop:10}}  onClick={()=>{setEditSource(true)}}>设置生源表</Button>
            </Row>
            {/* <Row>
                <Col xl={12} lg={24} md={24} sm={24} xs={24}>
                    <Card
                        title="拟邀名单"
                        extra={<a onClick={() => showDrawer(jsonData.proposedList_m, 'proposedList_m')}>添加</a>}
                    >
                        <SortableList axis="xy" list={jsonData.proposedList_m} onSortEnd={(e)=>onSortEnd(e,'proposedList_m')} />
                    </Card>
                </Col>
                <Col xl={12} lg={24} md={24} sm={24} xs={24}>
                    <Card
                        title="确定参与名单"
                        extra={<a onClick={() => showDrawer(jsonData.definiteList_m, 'definiteList_m')}>添加</a>}
                    >
                        <SortableList axis="xy"  list={jsonData.definiteList_m} onSortEnd={(e)=>onSortEnd(e,'definiteList_m')} />
                    </Card>
                </Col>
            </Row> */}
            <Drawer
                title="单位图库"
                placement="left"
                width={800}
                onClose={() => setOpen(false)}
                open={open}
                key={`open${open}`}
                extra={
                    <Space>
                        <Input value={searchValue} placeholder='搜索单位' onInput={doSearch}></Input>
                    </Space>
                }
                footer={
                    <div style={{paddingTop:10,height:50}}>
                        {
                            filterlist.length == list.length?
                            <Button style={{float:'left'}} onClick={selectAll}>
                                {selectList.length<list.length?'全选':'取消全选'}
                            </Button>:''
                        }
                        <Button  style={{float:'right'}} type="primary" onClick={selectFn}>
                            确定选中
                        </Button>
                    </div>
                }
            >
                <Checkbox.Group value={selectList} onChange={onCheckboxChange}>
                    <Row>
                        {
                            list.map(item => {
                                return (
                                   <Col style={{display:filterlist.filter((i)=>i.id==item.id).length?'block':"none"}} key={item.title + item.id}>
                                     <Checkbox checked={true} value={item.id}>
                                            <div style={{ width: 115, textAlign: 'center', margin: "5px 0" }}>
                                                <Image
                                                    placeholder={true}
                                                    preview={false}
                                                    width={70}
                                                    src={item.picUrl}
                                                    alt={item.title}
                                                />
                                                <div style={{marginTop:15}}>
                                                    {item.title.split("-")[0]}
                                                    <br />
                                                    {item.title.split("-")[1]}
                                                </div>
                                            </div>
                                        </Checkbox>
                                   </Col>
                                )
                            })
                        }
                    </Row>
                </Checkbox.Group>
            </Drawer>

            <Modal
                title="设置生源表"
                open={editSource}
                width={1100}
                onCancel={() => setEditSource(false)}
                footer={null}
            >
                <div style={{marginTop:30,marginBottom:10,fontSize:16}}>拟邀名单</div>
                <Table
                    dataSource={jsonData.proposedList}
                    rowKey="id"
                    columns={columns1}
                    scroll={{y:300}}
                    pagination={false}
                />
                <div style={{marginTop:30,marginBottom:10,fontSize:16}}>参与名单</div>
                <Table
                    dataSource={jsonData.definiteList}
                    rowKey="id"
                    scroll={{y:300}}
                    columns={columns2}
                    pagination={false}
                />
            </Modal>
        </div>
        </Spin>
    )

}
